import { c as _c } from "react/compiler-runtime";
import { useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { CameraErrorCause, ReceivedImagePayload } from '../../../types';
import { useNonIdDocMachine } from '../../context/non-id-doc-context';
import useDocName from '../../use-doc-name';
import MobileImageCaptureView from './mobile-image-capture-view';
const MobileImageCapture = () => {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.non-id-doc.pages.mobile-image-capture"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const [state, dispatch] = useNonIdDocMachine();
  const {
    hasBadConnectivity,
    requirement,
    allowPdf
  } = state.context;
  const {
    toast
  } = useToast();
  const docName = useDocName(requirement.config);
  let t1;
  if ($[1] !== dispatch) {
    t1 = payload => dispatch({
      type: "receivedDocument",
      payload
    });
    $[1] = dispatch;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onComplete = t1;
  let t2;
  if ($[3] !== dispatch) {
    t2 = () => dispatch({
      type: "navigatedToPrev"
    });
    $[3] = dispatch;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClickBack = t2;
  let t3;
  if ($[5] !== dispatch) {
    t3 = cause => dispatch({
      type: "cameraErrored",
      payload: {
        cause
      }
    });
    $[5] = dispatch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleCameraError = t3;
  let t4;
  if ($[7] !== dispatch) {
    t4 = () => dispatch({
      type: "cameraAccessDenied",
      payload: {
        status: "denied"
      }
    });
    $[7] = dispatch;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleCameraAccessDenied = t4;
  let t5;
  if ($[9] !== dispatch || $[10] !== t || $[11] !== toast) {
    t5 = () => {
      toast({
        title: t(_temp),
        description: t(_temp2),
        variant: "error"
      });
      dispatch({
        type: "cameraStuck"
      });
    };
    $[9] = dispatch;
    $[10] = t;
    $[11] = toast;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleCameraStuck = t5;
  let t6;
  if ($[13] !== allowPdf || $[14] !== docName || $[15] !== handleCameraAccessDenied || $[16] !== handleCameraError || $[17] !== handleCameraStuck || $[18] !== handleClickBack || $[19] !== hasBadConnectivity || $[20] !== onComplete || $[21] !== requirement) {
    t6 = <MobileImageCaptureView docName={docName} requirement={requirement} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} onComplete={onComplete} onBack={handleClickBack} onCameraError={handleCameraError} onCameraAccessDenied={handleCameraAccessDenied} onCameraStuck={handleCameraStuck} />;
    $[13] = allowPdf;
    $[14] = docName;
    $[15] = handleCameraAccessDenied;
    $[16] = handleCameraError;
    $[17] = handleCameraStuck;
    $[18] = handleClickBack;
    $[19] = hasBadConnectivity;
    $[20] = onComplete;
    $[21] = requirement;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export default MobileImageCapture;
function _temp($) {
  return $["camera-stuck"].title;
}
function _temp2($_0) {
  return $_0["camera-stuck"].description;
}